import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import WithAjax from '../../common/helpers/WithAjax'
import WithNotify from '../../common/helpers/WithNotify'
import {validateField} from '../../../actions/helpers/validation'
import {
  fetchProfileActorDataSuccess,
  validateProfileActorField,
  submitProfileActorFields,
  clearProfileActorFields} from '../../../actions/pages/profile-actor'
import EditForm from '../../../pages/EditForm'
import Textarea from '../../../pages/Textarea'
import Alert from '../../../ui-elements/alerts/Alert'
import '../../../css/ui-elements/modals.css'
import {fieldsToDataToSend} from '../../common/functions/convert'

class ActivateOrEditDirectorsCommentsPopup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      className: 'modal-primary',
      size: 'lg',
      errorMsg: null,
      directorsComments:''
    }

    this.toggle = this.toggle.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.openPopup = this.openPopup.bind(this)


  }

  openPopup() {
    this.toggle();
    let url = 'skillVendors/' + this.props.skillVendorId + '/profiles/voiceactor';
    this.props.clearProfileActorFields();
    this.setState({
      errorMsg: null
    })
    this.props.ajax.get(url, true, (data) => {
      this.props.fetchProfileActorDataSuccess(data);
    });
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    })
  }

  submitForm(event) {
    event.preventDefault();
  
    let directorsCommentsObj = this.props.fields;
    let newObj = {
      name: "Contents",
      value: directorsCommentsObj[0].value,
      type: "text",
      errors: [],
      rules: {title: "Director's comments", required: false}
    }

    let dataToSend = fieldsToDataToSend([newObj]);

    let url = 'skillvendors/' + this.props.skillVendorId + '/profiles/VoiceActor/directorscomments';

    this.props.ajax.put(
      url,
      JSON.stringify(dataToSend),
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      },
      (response) => {
        if (response.Status === 'OK') {
          this.props.sendData();
          this.toggle();
          this.props.clearProfileActorFields();
          this.props.notify(`Director's comments have been updated.`);
        }
        else{
          this.setState({
            errorMsg: `Can not update director's comments`
          })
        }
      })
  }

  render() {

    let fields = this.props.fields;

    return (
      <div style={{display: 'inline-block'}}>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          wrapClassName={this.state.className}
          size={this.state.size}>
          <ModalHeader toggle={this.toggle}>{"Edit director's comments"}</ModalHeader>
          <ModalBody>
            {this.state.errorMsg &&
              <Alert className="alert alert-danger alert-outline">
                {this.state.errorMsg}
              </Alert>
            }
            <EditForm
              title=""
              description="">
              {fields[0] && <Textarea field={fields[0]} validate={this.props.validateProfileActorField} rows="12" maxLength="1000"/>}
            </EditForm>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-primary btn-rounded" type="submit" onClick={this.submitForm}>
              Save
            </button>
            <button className="btn btn-default btn-rounded" onClick={this.toggle}>
              Close
            </button>
          </ModalFooter>
        </Modal>

        <button
          className="btn btn-primary btn-rounded ml-2"
          type="button"
          onClick={this.openPopup}>
          {'Edit'}
        </button>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  productionOverview: state.productionPage.overview,
  fields: state.profileActor.fields
})
const mapDispatchToProps = dispatch => ({
  fetchProfileActorDataSuccess: (activateData) => dispatch(fetchProfileActorDataSuccess(activateData)),
  submitProfileActorFields: fields => dispatch(submitProfileActorFields(fields)),
  validateProfileActorField: (value, field) => dispatch(validateProfileActorField(value, field)),
  clearProfileActorFields: () => dispatch(clearProfileActorFields()),
})
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithNotify,
  WithAjax)(ActivateOrEditDirectorsCommentsPopup)
